module.exports = __webpack_public_path__ + "img/remote.bb88250a.svg";